import { createSelector } from '@reduxjs/toolkit';

import { selectFlags } from './select-flags';

export const shouldExposeVideoPrivacyChange = createSelector(
  selectFlags,
  (flags) => {
    const shouldExposeVideoPrivacy = flags['expose-video-privacy-change'];
    return shouldExposeVideoPrivacy === undefined
      ? true
      : (shouldExposeVideoPrivacy as boolean);
  }
);
